import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { ITimeTrack } from '../time-track.interface';
import { TimeTrackService } from '../time-track.service';
import { forkJoin, Observable } from 'rxjs';
import { IWorker } from '../../../workers-page/workers/workers.interface';
import { ITask } from '../../../tasks-page/tasks/task.interface';
import { WorkersService } from '../../../workers-page/workers/workers.service';
import { TaskHttpService } from '../../../tasks-page/tasks/task-http.service';
import { DialogService } from '../../../../shared/services/dialog/dialog.service';
import { AuthService } from '../../../../shared/services/auth.service';
import { UtilsService } from '../../../../shared/services/utils.service';
import { IConfirmationDialogOptions } from '../../../../shared/services/dialog/confirmation-dialog/confirmation-dialog-options.interface';

let self: any;

@Component({
  selector: 'app-time-track-modal',
  templateUrl: './time-track-modal.component.html',
  styleUrls: ['./time-track-modal.component.css']
})
export class TimeTrackModalComponent implements OnInit {
  dialog: MatDialogRef<any>;
  readOnly: boolean = false;
  loading: boolean = false;
  saving: boolean = false;
  timeTrack!: ITimeTrack;
  form!: UntypedFormGroup;
  submitted = false;
  workers: IWorker[] = [];
  task!: ITask;
  isDev!: boolean;
  curr!: string;
  isManax!: boolean;

  editIndex!: number;
  period: any;
  editId: any;
  showPause: boolean = false;

  constructor(
    // private mapsAPILoader: MapsAPILoader,
    public _TimeTrackService: TimeTrackService,
    public _WorkersService: WorkersService,
    public _TaskHttpService: TaskHttpService,
    private _dialogService: DialogService,
    public dialogRef: MatDialogRef<any>,
    private fb: UntypedFormBuilder,
    private _viewContainerRef: ViewContainerRef,
    private ref: ChangeDetectorRef,
    private _AuthService: AuthService,
    public _UtilsService: UtilsService
  ) {
    self = this;
    this.dialog = dialogRef;
  }

  ngOnInit(): void {
    this.isManax = this._AuthService.isRole('manax');
    // this.mapsAPILoader.load();
    this.curr = this._AuthService.currency();
    this.isDev = this._AuthService.isRole('dev');

    this.detectPeriod();
    this.buildForm();
    // console.log(this.editIndex, this.timeTrack);

    // if (this.timeTrack._id) this.getTimeTrack();
    // else 
    // this.buildForm();
  }

  detectPeriod() {
    let startIndex: any;
    const timetracks: any = this.timeTrack.timetracks;

    if (!this.editId) {
      startIndex = undefined
      // console.error('Invalid editId');
      // return;
    }

    // Encuentra el índice correspondiente al _id dado
    if (this.editId) {
      startIndex = this.timeTrack.timetracks?.findIndex(track => track._id === this.editId);
    }

    while (startIndex >= 0 && timetracks[startIndex].type !== 'IN') {
      startIndex--;
    }

    if (startIndex < 0) {
      console.error('No event found with the given _id');
      return;
    }

    // Ahora puedes seguir con la lógica que ya tienes usando startIndex
    const tt = timetracks[startIndex];

    let period: any = {
      in: tt,
      startIndex: startIndex,
      pauses: [],
      out: null,
      outIndex: null,
      totalPauseTime: 0,
      totalWorkedTime: 0,
      formattedPauseTime: '0h 0m 0s',
      formattedWorkedTime: '0h 0m 0s'
    };

    let currentPause: any = null;

    for (let i = startIndex + 1; i < timetracks.length; i++) {
      const currentTT = timetracks[i];

      if (currentTT.type === 'OUT') {
        period.out = currentTT;
        period.outIndex = i;
        break;
      } else if (currentTT.type === 'PAUSE') {
        currentPause = { pause: currentTT, resume: null };
      } else if (currentTT.type === 'RESUME') {
        if (currentPause) {
          currentPause.resume = currentTT;
          period.pauses.push(currentPause);
          currentPause = null;
        }
      }
    }

    period.totalPauseTime = period.pauses.reduce((acc: any, pausePair: any) => {
      if (pausePair.resume) {
        const pauseTime = new Date(pausePair.resume.datetime).getTime() - new Date(pausePair.pause.datetime).getTime();
        return acc + pauseTime;
      }
      return acc;
    }, 0);

    if (period.out) {
      const inTime = new Date(period.in.datetime).getTime();
      const outTime = new Date(period.out.datetime).getTime();
      const totalWorkedTime = outTime - inTime - period.totalPauseTime;
      period.totalWorkedTime = totalWorkedTime;

      period.formattedWorkedTime = this.formatTime(totalWorkedTime);
      period.formattedPauseTime = this.formatTime(period.totalPauseTime);
    }

    this.period = period;
    console.log(this.period);
  }

  // Helper function to format milliseconds to 'h m s'
  formatTime(milliseconds: number): string {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return `${hours}h ${minutes}m ${seconds}s`;
  }


  /*
  getTimeTrack() {
    this.loading = true;
    console.log(this.timeTrack);
    this.buildForm();
    this.loading = false;
    
    this._TimeTrackService.getTimeTrack(this.timeTrack._id).subscribe((timeTrack) => {
      this.timeTrack = timeTrack;
      this.buildForm();
      this.loading = false;
    });
  }
  */

  get f() { return this.form.controls; }
  buildForm() {
    let clockIn;
    const timetracks: any = this.timeTrack.timetracks;

    if (this.period?.in) {
      clockIn = this._UtilsService.date.toLocale(this.period.in.datetime as any)
    } else {
      if (timetracks.length - 1 >= 0) {
        let lastDate = new Date(timetracks[timetracks.length - 1].datetime as any);
        lastDate.setMinutes(lastDate.getMinutes() + 1, 0, 0);
        clockIn = this._UtilsService.date.toLocale(lastDate.toISOString());
      } else {
        //const isoString = new Date(new Date().setSeconds(0, 0)).toISOString();
        clockIn = this._UtilsService.date.toLocale(this.timeTrack.scheduledStart as any)
      }
    }

    let clockOut
    if (this.period?.out) {
      clockOut = this._UtilsService.date.toLocale(this.period.out.datetime as any)
    } else {
      if (!this.period.in) {
        clockOut = ''
      } else {
        if (timetracks.length - 1 >= 2) {
          let lastDate = new Date(timetracks[timetracks.length - 1].datetime as any);
          lastDate.setMinutes(lastDate.getMinutes() + 1, 0, 0);
          clockOut = this._UtilsService.date.toLocale(lastDate.toISOString());
        } else {
          clockOut = this._UtilsService.date.toLocale(this.timeTrack.scheduledEnd as any);
        }
      }
    }

    this.form = this.fb.group({
      task: [this.timeTrack._id],
      worker: [_.get(this.timeTrack, 'worker._id', this.timeTrack.worker)],
      clockIn: [clockIn, [clockInValidator]],
      clockOut: [clockOut],
      pause: [],
    }, { validators: [clockInLowerThanOut(), inOutValidator(this.period, this.timeTrack, this._UtilsService)] });
  }

  setEditable() {
    this.readOnly = false;
  }

  onSubmit() {
    this.submitted = true;
    let data: ITimeTrack = _.cloneDeep(this.form.value);
    let taskStatus = _.get(this.timeTrack, 'task.status', this.timeTrack.task);
    if (this.form.invalid) return;

    this.saving = true;
    data.company = this._AuthService.companyId();
    data.origin = 'admin';

    if (data.clockIn) data.clockIn = new Date(data.clockIn).toISOString();
    else delete data.clockIn;
    if (data.clockOut) data.clockOut = new Date(data.clockOut).toISOString();
    else delete data.clockOut;

    // Crear o actualizar los timetracks
    const timetracks = _.cloneDeep(this.timeTrack.timetracks || []);
    const processTimeTracks = [];
    let periodIndex = (this.timeTrack.timetracks as any).findIndex((tt: any) => tt._id === this.period.in?._id);

    // Editar timetrack existente
    if (periodIndex !== -1) {
      // timetracks[periodIndex].datetime = data.clockIn;
      processTimeTracks.push({
        _id: timetracks[periodIndex]._id,
        type: timetracks[periodIndex].type, datetime: data.clockIn,
        task: timetracks[periodIndex].task, worker: timetracks[periodIndex].worker,
        company: timetracks[periodIndex].company, origin: timetracks[periodIndex].origin
      });
      if (this.period.out) {
        let outIndex = timetracks.findIndex(tt => tt._id === this.period.out._id);
        // timetracks[outIndex].datetime = data.clockOut;
        processTimeTracks.push({
          _id: timetracks[outIndex]._id,
          type: timetracks[outIndex].type, datetime: data.clockOut,
          task: timetracks[outIndex].task, worker: timetracks[outIndex].worker,
          company: timetracks[outIndex].company, origin: timetracks[outIndex].origin
        });
      }

      // Agregar nuevo timetrack de salida
      else if (data.clockOut) {
        processTimeTracks.push({
          type: 'OUT', datetime: data.clockOut,
          task: data.task, worker: data.worker,
          company: data.company, origin: data.origin
        });
      }
    }

    // Agregar nuevo timetrack de entrada
    else {
      processTimeTracks.push({
        type: 'IN', datetime: data.clockIn,
        task: data.task, worker: data.worker,
        company: data.company, origin: data.origin
      });

      // Agregar nuevo timetrack de salida
      if (data.clockOut) {
        processTimeTracks.push({
          type: 'OUT', datetime: data.clockOut,
          task: data.task, worker: data.worker,
          company: data.company, origin: data.origin
        });
      }
    }

    const observables: Observable<any>[] = [];

    for (let tt of processTimeTracks) {
      if (tt._id) observables.push(this._TimeTrackService.updateTimeTrack(tt))
      else observables.push(this._TimeTrackService.createTimeTrack(tt))
    }

    const sub = forkJoin(observables).subscribe({
      next: value => this.dialog.close(true),
      error: (e) => console.log(e),
    });

    /*
    if (this.timeTrack._id) {
      data._id = this.timeTrack._id;
      this._TimeTrackService.updateTimeTrack(data).subscribe({
        next: timeTrack => {
          if (data.clockOut && taskStatus != 'INVOICED') this.completeTask();
          else this.dialog.close(true);
        },
        error: err => { this.saving = false; }
      });
    } else {
      this._TimeTrackService.createTimeTrack(data).subscribe({
        next: timeTrack => {
          if (data.clockOut && taskStatus != 'INVOICED') this.completeTask();
          else this.dialog.close(true);
        },
        error: err => { this.saving = false; }
      });
    } */
  }

  completeTask() {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Completar",
      message: "¿Desea pasar este Trabajo a estado Completado?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };

    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._TaskHttpService.updateTask({
            _id: _.get(this.timeTrack, 'task._id', this.timeTrack.task) as any,
            company: this._AuthService.companyId(),
            status: 'COMPLETED'
          }).subscribe(ok => {
            this.dialog.close(true);
          })
        }
        else this.dialog.close(true);
      });
  }
}

function clockInValidator(control: AbstractControl): any {
  if (control.value && (new Date(control.value).getTime() < (new Date().getTime() - (365 * 24 * 60 * 60 * 1000)))) {
    return { tooEarly: true };
  }
}

function clockInLowerThanOut() {
  return (group: UntypedFormGroup) => {
    let clockInControl = group.controls['clockIn'];
    let clockOutControl = group.controls['clockOut'];
    if ((clockOutControl.value) && (clockInControl.value > clockOutControl.value)) clockOutControl.setErrors({ lowerThanOut: true })
  }
}

function inOutValidator(period: any, tt: ITimeTrack, utilsService: UtilsService) {
  return (group: UntypedFormGroup) => {
    let clockInControl = group.controls['clockIn'];
    let clockOutControl = group.controls['clockOut'];
    let errors = {};
    const timetracks: any = tt.timetracks;

    //--------- (creando)-------------
    if (period.in === undefined && timetracks.length > 0) {
      // console.log(clockInControl.value)
      // console.log("eeeeeee")
      if (utilsService.date.toLocale(timetracks[timetracks.length - 1].datetime) >= clockInControl.value) {
        errors = { ...errors, lowerThanLastOut: true };
      }
    }
    //----------si tiene un out atras----------------------
    if (period.startIndex !== 0 && period.in !== undefined && timetracks[period.startIndex - 1]) {
      // console.log(tt.timetracks[period.startIndex-1].datetime)
      // console.log(this._UtilsService.date.toLocale(tt.timetracks[period.startIndex-1].datetime), clockInControl.value)
      if (utilsService.date.toLocale(timetracks[period.startIndex - 1].datetime) >= clockInControl.value) {
        errors = { ...errors, lowerThanLastOut: true };
      }
      if (clockInControl.value >= clockOutControl.value) {
        errors = { ...errors, lowerThanLastIn: true };
      }
    }
    //----------si tiene un in adelante----------------
    if (period.outIndex !== 0 && period.in !== undefined && period.out !== null && timetracks[period.outIndex + 1]) {
      // console.log(clockInControl.value, clockOutControl.value)
      // console.log(period.outIndex, period.outIndex+1)
      // console.log(tt.timetracks)
      // console.log(tt.timetracks[period.outIndex+1])
      // console.log(this._UtilsService.date.toLocale(tt.timetracks[period.outIndex+1].datetime))
      // console.log(this._UtilsService.date.toLocale(tt.timetracks[period.outIndex+1].datetime), clockOutControl.value)
      if (utilsService.date.toLocale(timetracks[period.outIndex + 1].datetime) <= clockOutControl.value) {
        errors = { ...errors, higherThanNextIn: true };
      }
      if (clockInControl.value >= clockOutControl.value) {
        errors = { ...errors, lowerThanLastIn: true };
      }
    }
    //-----------si NO tiene un in adelante (Ultimo)-------------
    if (period.in !== undefined && period.outIndex !== 0 && period.out === null) {
      // console.log(clockInControl.value, clockOutControl.value)
      // console.log(tt.timetracks)
      // console.log(tt.timetracks[tt.timetracks.length-1])
      // console.log(clockInControl.value)
      // console.log(clockInControl.value, clockOutControl.value)
      if (clockInControl.value >= clockOutControl.value) {
        errors = { ...errors, lowerThanLastIn: true };
      }
    }

    if (Object.keys(errors).length === 0) {
      clockInControl.setErrors(null);
      clockOutControl.setErrors(null);
    } else {
      clockInControl.setErrors(errors);
      clockOutControl.setErrors(errors);
    }
  };
}